import { NgComponentOutlet } from '@angular/common';
import { Component, inject, OnInit, Type } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConsultationRequestComponent } from '@components/consultation-request/consultation-request.component';
import { ConsultationRequestFormComponent } from '@components/consultation-request/consultation-request-form/consultation-request-form.component';
import { DynamicConsultationRequestFormComponent } from '@components/consultation-request/dynamic-consultation-request-form/dynamic-consultation-request-form.component';
import { Glp1ConsultationRequestFormComponent } from '@components/consultation-request/glp1-consultation-request-form/glp1-consultation-request-form.component';
import { Glp1RenewalConsultationRequestFormComponent } from '@components/consultation-request/glp1-renewal-consultation-request-form/glp1-renewal-consultation-request-form.component';
import { TrtConsultationRequestFormComponent } from '@components/consultation-request/trt-consultation-request-form/trt-consultation-request-form.component';
import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { ConsultationStorageService } from '@services/consultation-storage.service';

@Component({
  selector: 'app-consultation-page',
  imports: [NgComponentOutlet],
  template: `
    @if (componentToRender) {
      <ng-container *ngComponentOutlet="componentToRender" />
    }
  `,
})
export class ConsultationRequestPageComponent implements OnInit {
  public componentToRender: Type<ConsultationRequestFormComponent | ConsultationRequestComponent>;

  private consultationStorageService = inject(ConsultationStorageService);
  private route = inject(ActivatedRoute);

  /**
   * Initializes the component by subscribing to the route data to determine which component to render
   */
  public ngOnInit(): void {
    this.route.data.subscribe((data) => {
      if (data['consultationOrderDetails']) {
        this.componentToRender = this.getConsultationComponent();
      }
    });
  }

  /**
   * Gets the consultation component based on the treatment type
   *
   * @returns {Type<ConsultationRequestFormComponent | ConsultationRequestComponent>} the consultation component
   */
  private getConsultationComponent(): Type<ConsultationRequestFormComponent | ConsultationRequestComponent> {
    switch (this.consultationStorageService.treatmentType) {
      case ConsultationTreatmentTypes.Nurse:
      case ConsultationTreatmentTypes.Std:
        return ConsultationRequestComponent;
      case ConsultationTreatmentTypes.Glp1:
        return Glp1ConsultationRequestFormComponent;
      case ConsultationTreatmentTypes.Glp1Renewal:
        return Glp1RenewalConsultationRequestFormComponent;
      case ConsultationTreatmentTypes.Trt:
      case ConsultationTreatmentTypes.TrtRenewal:
        return TrtConsultationRequestFormComponent;
      default:
        return DynamicConsultationRequestFormComponent;
    }
  }
}
